// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton_backBtn__tx8V6","backBtnIcon":"BackButton_backBtnIcon__t-Joo"};